var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21H4C3.45 21 3 20.55 3 20C3 19.45 3.45 19 4 19H20C20.55 19 21 19.45 21 20C21 20.55 20.55 21 20 21ZM14 17H4C3.45 17 3 16.55 3 16C3 15.45 3.45 15 4 15H14C14.55 15 15 15.45 15 16C15 16.55 14.55 17 14 17ZM20 13H4C3.45 13 3 12.55 3 12C3 11.45 3.45 11 4 11H20C20.55 11 21 11.45 21 12C21 12.55 20.55 13 20 13ZM14 9H4C3.45 9 3 8.55 3 8C3 7.45 3.45 7 4 7H14C14.55 7 15 7.45 15 8C15 8.55 14.55 9 14 9ZM21 4C21 4.55 20.55 5 20 5H4C3.45 5 3 4.55 3 4C3 3.45 3.45 3 4 3H20C20.55 3 21 3.45 21 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAlignLeft);
export default __webpack_public_path__ + "static/media/TextAlignLeft.b80e33c1e2286103e3f85f4493929254.svg";
export { ForwardRef as ReactComponent };